import api from "../../../api/axios";

export function listPropertyPresentations(propertyId, { signal } = {}) {
  return api
    .get(`/realty/properties/${propertyId}/shares/`, { signal })
    .then((res) => res.data);
}

export function createPropertyPresentation(propertyId, body) {
  return api
    .post(`/realty/properties/${propertyId}/shares/`, body)
    .then((res) => res.data);
}

export function fetchPropertyPresentation(propertyId, shareId, { signal } = {}) {
  return api
    .get(`/realty/properties/${propertyId}/shares/${shareId}/`, { signal })
    .then((res) => res.data);
}

export function updatePropertyPresentation(propertyId, shareId, body) {
  return api
    .patch(`/realty/properties/${propertyId}/shares/${shareId}/`, body)
    .then((res) => res.data);
}

export function revokePropertyPresentation(propertyId, shareId) {
  return api
    .post(`/realty/properties/${propertyId}/shares/${shareId}/revoke/`)
    .then((res) => res.data);
}

export function reactivatePropertyPresentation(propertyId, shareId, body) {
  const path = `/realty/properties/${propertyId}/shares/${shareId}/reactivate/`;
  const request =
    body === undefined ? api.post(path) : api.post(path, body);
  return request.then((res) => res.data);
}

export function rotatePropertyPresentation(propertyId, shareId) {
  return api
    .post(`/realty/properties/${propertyId}/shares/${shareId}/rotate/`)
    .then((res) => res.data);
}

export function fetchPropertyPresentationAnalytics(propertyId, shareId, { signal } = {}) {
  return api
    .get(`/realty/properties/${propertyId}/shares/${shareId}/analytics/`, { signal })
    .then((res) => res.data);
}

export const PRESENTATION_WRITE_FIELDS = [
  "internal_label",
  "client",
  "price_mode",
  "custom_price",
  "custom_currency",
  "location_precision",
  "presentation_note",
  "include_video",
  "contact_phone",
  "contact_email",
  "include_contact_avatar",
  "expires_at",
  "media",
];
